import { AfterViewInit, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SystemAlertType } from '@services/system-alerts/';
import { fadeInAnimation, slideInOutAnimation } from '@shared/animations';
import { GATrackingService } from '@tcp13equals2/z5-lib';

import { ProgressIndicatorService } from './services/progress';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	animations: [slideInOutAnimation, fadeInAnimation]
})
export class AppComponent implements OnInit, AfterViewInit {
	public bannerAlertTypes: SystemAlertType[] = [SystemAlertType.all];

	constructor(
		private progressIndicatorService: ProgressIndicatorService,
		private gaTrackingService: GATrackingService,
	) {}

	public ngOnInit(): void {
		this.gaTrackingService.startTracking();
		this.progressIndicatorService.spinner(true);
	}

	public ngAfterViewInit(): void {
		if (this.progressIndicatorService.hasSpinner()) {
			this.progressIndicatorService.spinner(false);
		}
	}

	public prepareRoute(outlet: RouterOutlet): boolean {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.hasOwnProperty('animation');
	}
}
